<template>
  <Content class="content">
    <div class="page-heading">
      <h2>供应商系统</h2>
      <div class="page-heading__user">
        <span>{{ suppName }}</span>
        <Button @click="clickLogout">退出登录</Button>
      </div>
    </div>

    <QueryForm @on-query="onQuery" @on-insert="onInsert" />
    <div v-if="isAdminUser" class="admin-actions">
      <Button icon="md-people" @click="userInfoModal = true">用户信息</Button>
      <Button type="primary" icon="md-cube" @click="productInfoModal = true">商品信息</Button>
    </div>

    <List :data="list" :token="token" @on-detail="onItemDetail" @on-edit="onItemEdit" @on-delete="onItemDelete" :change="onChangePage" :total="total" :page-size="queryData.pageSize" :current="queryData.page" />
    <DetailModal v-model="detailModal" :data="detailData" :token="token" ref="detailModalRef" />
    <EditModal v-model="editModal" ref="editModalRef" :saving="saving" @on-save="onEditSave" />
    <UserInfoModal v-model="userInfoModal" />
    <ProductInfoModal v-model="productInfoModal" />
  </Content>
</template>

<script>
import List from './components/list'
import DetailModal from './components/detailModal'
import EditModal from './components/editModal'
import QueryForm from './components/queryForm'
import UserInfoModal from './components/userInfoModal'
import ProductInfoModal from './components/productInfoModal'
import {clearSession, ensureSessionActive, startSessionGuard} from '@/plugin/callApi'

export default {
  name: 'SupplierAccount',
  components: {List, DetailModal, EditModal, QueryForm, UserInfoModal, ProductInfoModal},
  data () {
    return {
      list: [],
      editModal: false,
      saving: false,
      detailData: {},
      detailModal: false,
      userInfoModal: false,
      productInfoModal: false,
      suppName: '',
      queryData: {page: 1, pageSize: 20},
      total: 0,
      token: '',
      isAdminUser: false,
      sessionGuardStop: null
    }
  },
  created () {
    if (this.loadUser()) {
      this.loadData()
    }
  },
  mounted () {
    if (sessionStorage.getItem('userData')) {
      this.sessionGuardStop = startSessionGuard(this)
    }
  },
  beforeDestroy () {
    if (this.sessionGuardStop) {
      this.sessionGuardStop()
      this.sessionGuardStop = null
    }
  },
  methods: {
    loadUser () {
      let userData = null
      try {
        userData = JSON.parse(sessionStorage.getItem('userData'))
      } catch (e) {
        userData = null
      }
      if (!userData) {
        this.$router.replace({path: '/'})
        return false
      }
      if (!ensureSessionActive(this)) {
        return false
      }
      this.isAdminUser = ['userAcount', 'userName', 'userCode'].some(key => String(userData[key] || '').trim().toLowerCase() === 'admin')
      this.suppName = userData.userName || userData.cusName || userData.loginCode
      this.token = userData.downToken || ''
      return true
    },
    clickLogout () {
      clearSession()
      this.$router.replace({path: '/'})
    },
    onQuery (queryData) {
      this.queryData = Object.assign({}, this.queryData, queryData, {page: 1})
      this.loadData()
    },
    onInsert () {
      this.$refs.editModalRef.setData({})
      this.editModal = true
    },
    onItemDetail (params) {
      this.detailData = params.row
      this.detailModal = true
    },
    onItemEdit (params) {
      this.$refs.editModalRef.setData(Object.assign({}, params.row))
      this.editModal = true
    },
    onItemDelete (params) {
      this.$Modal.confirm({title: '删除提示', content: '<p>确定要进行删除操作吗?</p>', onOk: () => this.httpDeleteById(params.row.id)})
    },
    onChangePage (page) {
      const nextPage = Number(page)
      this.queryData.page = Number.isFinite(nextPage) && nextPage > 0 ? nextPage : 1
      this.loadData()
    },
    onEditSave (data) {
      if (this.saving) return
      this.saveReport(data)
    },
    saveReport (data) {
      if (this.saving) return
      this.saving = true
      this.$fetch('CusFahuo/save', data, 'POST').then(res => {
        this.saving = false
        this.$Message.success('保存成功')
        this.loadData()
        this.editModal = false
      }, () => {
        this.saving = false
      })
    },
    loadData () {
      const page = Number(this.queryData.page)
      const pageSize = Number(this.queryData.pageSize)
      this.queryData.page = Number.isFinite(page) && page > 0 ? page : 1
      this.queryData.pageSize = Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 20
      this.$fetch('CusFahuo/getList', this.queryData).then(res => {
        this.list = (res.data && res.data.list) || []
        this.total = Number(res.data && res.data.total) || 0
      })
    },
    httpDeleteById (id) {
      this.$fetch('CusFahuo/del', {id}).then(() => {
        this.$Message.success('删除成功')
        this.loadData()
      })
    }
  }
}
</script>

<style scoped>
.content { padding: 20px; margin: 20px; background: #fff; }
.page-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 42px; }
.page-heading h2 { margin: 0; }
.page-heading__user { display: flex; align-items: center; gap: 12px; }
.admin-actions { display: flex; justify-content: flex-end; gap: 10px; margin: 4px 0 16px; }
</style>
